import { render, staticRenderFns } from "./AMfaAuthenticator.vue?vue&type=template&id=5de88aa8&"
import script from "./AMfaAuthenticator.vue?vue&type=script&lang=js&"
export * from "./AMfaAuthenticator.vue?vue&type=script&lang=js&"
import style0 from "./AMfaAuthenticator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports